import { ComponentDetailsModel } from 'models/certificate.model';

export type ComponentConfigModel = {
  id: keyof ComponentDetailsModel;
  suffix: string;
};

const componentConfig: ComponentConfigModel[] = [
  {
    id: 'componentName',
    suffix: '',
  },
  {
    id: 'componentId',
    suffix: '',
  },
  {
    id: 'countryOfOrigin',
    suffix: '',
  },
  {
    id: 'batchNumber',
    suffix: '',
  },
  {
    id: 'percentRecycled',
    suffix: '%',
  },
  {
    id: 'factory',
    suffix: '',
  },
  {
    id: 'percentShare',
    suffix: '%',
  },
];

export { componentConfig };
